import { type Line } from '~/components/BettingInsights/types';

export const formatLine = (line: Line) => {
	const signs = {
		Over: 'O ',
		Under: 'U ',
	};

	const lineSign = signs[line.sign as keyof typeof signs] || line.sign;

	return `${lineSign}${line.absolute}`;
};
